// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2284":"982a2a40a0080442","2431":"50a12a0204630d88","4238":"79f3fa49b7759231","6908":"da13fc6325e591fc"}[chunkId] + ".css";
};